import { createContext } from '@wordpress/element'

export const EditorContext = createContext('gutenberg')
